import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class serviceApi {
  static uri = "a/internet/serviceInfo";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  get(fileId: number, page: number, rows: number) {
    return getData({
      uri: serviceApi.uri,
      params: `?fileId=${fileId}&page=${page}&rows=${rows}`,
      context: this.context,
    });
  }
}
